export default "__VITE_ASSET__Ch$4louK__"